"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantQuickActions = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@assistant-ui/react");
const _ui_1 = require("@ui");
const util_1 = require("@app/util");
require("./assistant-quick-actions.scss");
/**
 * The manager's shortcuts, permanently above the composer. Replaces the empty-state starter
 * cards, whose whole problem was disappearing the moment a conversation
 * started — these do not.
 *
 * **A chip inserts; it never sends.** `ThreadPrimitive.Suggestion` sends only when it is passed
 * `send`, which the starter cards did and this deliberately does not: with `send` absent the
 * primitive writes the prompt into the composer instead, `clearComposer` defaulting to
 * `true` so it replaces rather than appends. A chip that sent would spend a message from the
 * business's quota without the manager choosing to, and would leave no chance to adjust the
 * wording first.
 *
 * `disabled` is a plain HTML button attribute here, not an invented prop: the primitive is a
 * `<button>` and forwards everything it does not consume, so `disabled` reaches the element and
 * ORs with the library's own reason for disabling it.
 */
const AssistantQuickActions = ({ actions, disabled, onInsert, }) => {
    // The heading folds the chips away and back (owner's review, 2026-09-21). Local and
    // unpersisted on purpose: open is the default every mount, and the strip is one of the
    // reasons the sidebar is worth expanding, so it should not stay hidden across sessions.
    const [isOpen, setIsOpen] = react_1.default.useState(true);
    return (react_1.default.createElement("div", { className: 'ds-ma-quick-actions', "data-testid": 'ai-quick-actions' },
        react_1.default.createElement("button", { type: 'button', className: 'ds-ma-quick-actions-toggle', onClick: () => setIsOpen((open) => !open), "aria-expanded": isOpen },
            react_1.default.createElement(_ui_1.Text, { className: 'ds-ma-quick-actions-heading', type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.MEDIUM }, (0, util_1.t)('ASSISTANT.quickActionsHeading'))),
        isOpen && (react_1.default.createElement("div", { className: 'ds-ma-quick-actions-list' }, actions.map(({ id, label, prompt, ico }) => (react_1.default.createElement(react_2.ThreadPrimitive.Suggestion, { key: id, className: 'ds-ma-quick-action', prompt: prompt, disabled: disabled, onClick: onInsert },
            react_1.default.createElement(_ui_1.Icon, { ico: ico, size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.BLACK }),
            react_1.default.createElement("span", { className: 'ds-ma-quick-action-label' }, label))))))));
};
exports.AssistantQuickActions = AssistantQuickActions;
exports.default = AssistantQuickActions;
